var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Text } from '../Text';
import { CALENDAR_DATA_KEYS } from './dataHooks';
import { st, classes } from './CalendarCell.st.css';
import { CalendarCellAlignment, CalendarCellTimes, } from './types';
/** CalendarCell */
var CalendarCell = /** @class */ (function (_super) {
    __extends(CalendarCell, _super);
    function CalendarCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarCell.prototype.getDataAttributes = function () {
        var _a;
        var _b = this.props, stretchable = _b.stretchable, current = _b.current, timeType = _b.timeType, alignment = _b.alignment;
        return _a = {},
            _a[CALENDAR_DATA_KEYS.Stertchable] = stretchable,
            _a[CALENDAR_DATA_KEYS.TimeType] = timeType,
            _a[CALENDAR_DATA_KEYS.Current] = current,
            _a[CALENDAR_DATA_KEYS.Alignment] = alignment,
            _a;
    };
    CalendarCell.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, stretchable = _a.stretchable, current = _a.current, alignment = _a.alignment, timeType = _a.timeType, className = _a.className;
        return (React.createElement("div", __assign({}, this.getDataAttributes(), { "data-hook": this.props['data-hook'], className: st(classes.root, { stretchable: stretchable, current: current, alignment: alignment, timeType: timeType }, className) }),
            React.createElement("div", { className: classes.innerContainer },
                React.createElement(Text, { className: classes.title }, title),
                children)));
    };
    CalendarCell.displayName = 'CalendarCell';
    CalendarCell.defaultProps = {
        stretchable: false,
        current: false,
        alignment: CalendarCellAlignment.left,
        timeType: CalendarCellTimes.futureDate,
    };
    return CalendarCell;
}(React.Component));
export { CalendarCell };
//# sourceMappingURL=CalendarCell.js.map